import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-icon',
  imports: [],
  templateUrl: './spinner-icon.component.html',
  styleUrls: ['./spinner-icon.component.scss'],
})
export class SpinnerIconComponent {}
